<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on }">
        <v-btn color="blue darken-1" class="mr-0" v-on="on" dark small round>Setting</v-btn>
        <!-- <v-btn color="red lighten-2" dark v-on="on">
          Click Me
        </v-btn> -->
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Dual Price Setting
        </v-card-title>

        <v-container grid-list-lg>
          <v-layout column>
            <v-layout row wrap align-center>
              <v-flex>Dual Pricing</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <toggle-button v-model="dualPrice" @change="updateCashDiscount()"
                  :labels="{ checked: 'ON', unchecked: 'OFF' }" :color="{
                    checked: '#21BED5',
                    unchecked: '#B7C4D3',
                    disabled: '#CCCCCC',
                  }" :value="dualPrice" :sync="true"></toggle-button>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout row wrap align-center>
              <v-flex>Dual Pricing Rate</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <v-text-field v-model="dualPriceRate" :disabled="!dualPrice" label="Percentage"
                  hide-details></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout column class="ml-5 mt-2" v-if="dualPrice">
              <v-flex>
                <v-layout row wrap>
                  <v-flex>Bill Payment</v-flex>
                  <v-spacer></v-spacer>
                  <v-flex class="text-xs-right">
                    <toggle-button v-model="billPaymentDualPrice" :labels="{ checked: 'ON', unchecked: 'OFF' }"
                      :value="billPaymentDualPrice" :sync="true"></toggle-button>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row wrap>
                  <v-flex>Repair </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex class="text-xs-right">
                    <toggle-button v-model="repairDualPrice" :labels="{ checked: 'ON', unchecked: 'OFF' }"
                      :value="repairDualPrice" :sync="true"></toggle-button>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row wrap>
                  <v-flex>Layaway</v-flex>
                  <v-spacer></v-spacer>
                  <v-flex class="text-xs-right">
                    <toggle-button v-model="layawayDualPrice" :labels="{ checked: 'ON', unchecked: 'OFF' }"
                      :value="layawayDualPrice" :sync="true"></toggle-button>
                  </v-flex>
                </v-layout>
                <v-divider></v-divider>
                <v-layout row wrap>
                  <v-flex>Used Items</v-flex>
                  <v-spacer></v-spacer>
                  <v-flex class="text-xs-right">
                    <toggle-button v-model="usedItemDualPrice" :labels="{ checked: 'ON', unchecked: 'OFF' }"
                      :value="usedItemDualPrice" :sync="true"></toggle-button>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center v-if="dualPrice">
              <v-flex>Dual Pricing Label</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <v-text-field v-model="dualPriceLabel" :disabled="!dualPrice" hide-details></v-text-field>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>

            <v-layout row wrap align-center v-if="dualPrice">
              <v-flex>Dual Pricing Started At</v-flex>
              <v-spacer></v-spacer>
              <v-flex class="text-xs-right">
                <DateTimePicker :showIcon="false" :range="false" autoSubmit="autoSubmit" :clearable="false"
                  :hideTime="true" label="Due Date" ref="dateTimePicker" v-on:input="setDate"
                  :initStartDate="$moment(dualPriceStartedAt)" :noFuture="true"></DateTimePicker>
              </v-flex>
            </v-layout>

          </v-layout>
        </v-container>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" flat @click="close()">
            Close
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" dark @click="save()">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import locationService from '../service.js';
import DateTimePicker from "../../Global/components/DateTimePicker.vue";

export default {
  data() {
    return {
      dialog: false,
      dualPriceRate: 0,
      dualPrice: false,
      dualPriceLabel: 'Cash Discount',
      dualPriceStartedAt: new Date(),
      billPaymentDualPrice: false,
      repairDualPrice: false,
      usedItemDualPrice: false,
      layawayDualPrice: false,
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.setStatus();
      }
    },
  },
  components: {
    DateTimePicker,
  },
  computed: {
    ...mapGetters('location', ['location', 'organization']),
  },
  methods: {
    ...mapActions('location', ['setLocation']),
    setDate(val) {
      this.dualPriceStartedAt = val;
    },
    setStatus() {
      // console.log('getting location', this.location)
      this.billPaymentDualPrice = this.location.billPaymentDualPrice;
      this.repairDualPrice = this.location.repairDualPrice;
      this.usedItemDualPrice = this.location.usedItemDualPrice;
      this.layawayDualPrice = this.location.layawayDualPrice;
      this.dualPrice = this.location.dualPrice;
      this.dualPriceRate = this.location.dualPriceRate;
      if (this.location.dualPriceLabel) {
        this.dualPriceLabel = this.location.dualPriceLabel;
      }
      if (this.location.dualPriceStartedAt) {
        this.dualPriceStartedAt = this.location.dualPriceStartedAt;
      }
    },
    close() {
      this.dialog = false
    },
    updateStore(data) {
      return locationService
        .updateStore(this.location.storeID, data)
        .then((result) => {
          this.$swal
            .mixin({
              toast: true,
              position: 'top-end',
              showConfirmButton: false,
              timer: 3000,
            })
            .fire({
              type: 'success',
              title: 'Update Successfully',
            });
          this.setLocation(this.location.storeID);
        });
    },
    updateCashDiscount() {
      // Check if dualPrice is true
      if (this.dualPrice) {
        // Set default cash discount rate if it's zero
        console.log('dualPriceRate', this.dualPriceRate)
        if (this.dualPriceRate === 0 || this.dualPriceRate === undefined || this.dualPriceRate === null) {
          this.dualPriceRate = 3.5; // Set default value
        }

        // Ensure cash discount rate does not exceed 4.5% and is not less than 3%
        if (this.dualPriceRate > 4.5) {
          this.dualPriceRate = 4.5; // Cap the value at 4.5%
        } else if (this.dualPriceRate < 3) {
          this.dualPriceRate = 3; // Set the minimum value to 3%
        }
      } else {
        this.dualPriceRate = 0
      }


      // const data = {
      //   dualPrice: this.dualPrice,
      //   dualPriceRate: this.dualPriceRate,
      //   billPaymentDualPrice: this.billPaymentDualPrice,
      //   repairDualPrice: this.repairDualPrice,
      //   usedItemDualPrice: this.usedItemDualPrice,
      //   layawayDualPrice: this.layawayDualPrice,
      // };
      // // console.log('updateTwilioAlert', data);
      // this.updateStore(data);

      // this.close()
    },
    save() {
      const data = {
        dualPrice: this.dualPrice,
        dualPriceRate: this.dualPriceRate,
        billPaymentDualPrice: this.billPaymentDualPrice,
        repairDualPrice: this.repairDualPrice,
        usedItemDualPrice: this.usedItemDualPrice,
        layawayDualPrice: this.layawayDualPrice,
        dualPriceLabel: this.dualPriceLabel,
        dualPriceStartedAt: this.dualPriceStartedAt,
      };


      // console.log('updateTwilioAlert', data);
      this.updateStore(data);

      this.close()
    },
  }
}
</script>
